import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AddNew from "./AddNew";
import Rename from "./Rename";
import Delete from "./Delete";
import apis from "../services";
import DEX from "./DEX";
import DynamicHeader from "../Header/DynamicHeader";
function Favorites() {
  const userId = localStorage.getItem("userId");
  const [watchlists, setWatchlists] = useState([]);
  const [newWatchlistName, setNewWatchlistName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedWatchlistId, setSelectedWatchlistId] = useState(null);
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  useEffect(() => {
  }, [userId]);
  const handleCreateWatchlist = async () => {
    if (newWatchlistName.trim() === "") {
      alert("Please enter a valid watchlist name.");
      return;
    }
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }
    const body = { Name: newWatchlistName, userId };
    try {
      const newWatchlist = await apis.createwatch(body);
      if (newWatchlist.success) {
        setNewWatchlistName(""); 
        const response = await apis.watchnew();
        if (response.success) {
          const userWatchlists = response.data.filter((list) => list.userId === userId);
          setWatchlists(userWatchlists);
        } else {
          console.error("Failed to fetch updated watchlists:", response.message);
        }
      } else {
        console.error("Failed to create watchlist:", newWatchlist.message);
      }
    } catch (error) {
      console.error("Error creating watchlist:", error);
    }
  };
  const handleRenameWatchlist = async () => {
    if (!selectedWatchlistId || newWatchlistName.trim() === "") {
      alert("Please select a watchlist and enter a valid name.");
      return;
    }
    const body = { Name: newWatchlistName, userId, watchlistId: selectedWatchlistId };
    try {
      const response = await apis.renamewatchlist(body);
      if (response.success) {
        setNewWatchlistName("");
   

      
        const updatedWatchlists = await apis.watchnew();
        setWatchlists(updatedWatchlists.data);
      } else {
        console.error("Failed to rename watchlist:", response.message);
      }
    } catch (error) {
      console.error("Error renaming watchlist:", error);
    }
  };

  return (
    <div className="invest-background">
      {/* Header */}
      <div className="header-container">
        {/* <div className="header-content">
          <h1 className="header-title">
            <Link to="/home" style={{ textDecoration: "none", color: "inherit" }}>
              My Watchlist
            </Link>
          </h1>
        </div> */}
           {/* <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna"> My Watchlist </span><br></br><br></br>
              
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
  
            </h2>
          
          </div>
          <div className="details-borders"></div>
       
        </div> */} <DynamicHeader/>
      {/* <div style={{height: "90px"}}></div> */}
        <div className="watch-list-container">
          <div className="watch-list-tabs">
            <div className="watch-list-new-tab">           
            </div>
    

          </div>
        </div>
      </div>

                    <div>
                    <DEX/>
                    </div>
    </div>
  );
}

export default Favorites;
